import { AttributesMixin, define, Model } from "@type-r/models";
import { getAuthorizationBearer, getPlatformCode, restfulIO } from "./endpoint";


export interface InvoiceUnarchive extends AttributesMixin<typeof InvoiceUnarchive> { }
@define
export class InvoiceUnarchive extends Model {
  static endpoint = restfulIO('api/v1/assetmaster/invoices/assets/unarchive');

  static attributes = {
    status: String
  }

  async do(ids: string, facilityIds:any): Promise<Response> {
    const url = `api/v1/assetmaster/invoices/assets/unarchive`;
    
    return await fetch(url, {
      method: 'PUT',
      headers: new Headers({
        'Content-Type': 'application/json',
        "Authorization": getAuthorizationBearer(),
        'X-Platform-Code': getPlatformCode()
      }),
      body: JSON.stringify({
        "assetIds": ids,
        "facilityIds": facilityIds ? facilityIds.map(f => f.id) : []
      })
    });
  }
}
